(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-collection"] && !Shopify.designMode) return;
  try {
    
(() => {
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  function setup(scope = document) {
    scope.querySelectorAll('[data-essentials]').forEach(section => {
      if (section.dataset.ready) return;
      section.dataset.ready = 'true';
      const rail = section.querySelector('.essentials-track');
      const cards = [...rail.querySelectorAll('.essentials-card')];
      const filters = [...section.querySelectorAll('[data-essential-filter]')];
      const arrows = [...section.querySelectorAll('[data-essential-slide]')];
      const dialog = section.querySelector('dialog');
      const body = dialog.querySelector('[data-essential-dialog-body]');
      let opener;
      let previousOverflow;
      section.querySelector('.essentials-filters').hidden = false;
      section.querySelector('.essentials-arrows').hidden = false;
      filters.forEach(button => {
        const category = button.dataset.essentialFilter;
        if (category !== 'all' && !cards.some(card => card.dataset.careCategory === category)) button.hidden = true;
        button.addEventListener('click', () => {
          filters.forEach(filter => filter.setAttribute('aria-pressed', String(filter === button)));
          cards.forEach(card => { card.hidden = category !== 'all' && card.dataset.careCategory !== category; });
          rail.scrollTo({ left: 0, behavior: 'instant' });
          const status = section.querySelector('[data-essential-status]');
          status.textContent = `${button.textContent}: ${cards.filter(card => !card.hidden).length} ${status.dataset.resultLabel}`;
          updateArrows();
        });
      });
      function updateArrows() {
        arrows[0].disabled = rail.scrollLeft < 4;
        arrows[1].disabled = rail.scrollLeft >= rail.scrollWidth - rail.clientWidth - 4;
      }
      function slide(direction) {
        const card = cards.find(item => !item.hidden);
        const amount = card ? card.getBoundingClientRect().width + parseFloat(getComputedStyle(rail).gap) : rail.clientWidth;
        rail.scrollBy({ left: amount * direction, behavior: reduced.matches ? 'instant' : 'smooth' });
      }
      arrows.forEach(button => button.addEventListener('click', () => slide(Number(button.dataset.essentialSlide))));
      rail.addEventListener('scroll', updateArrows, { passive: true });
      new ResizeObserver(updateArrows).observe(rail);
      rail.addEventListener('keydown', event => {
        if (event.target === rail && ['ArrowLeft', 'ArrowRight'].includes(event.key)) {
          event.preventDefault(); slide(event.key === 'ArrowRight' ? 1 : -1);
        }
      });
      let pointer;
      let suppressClick = false;
      rail.addEventListener('pointerdown', event => {
        if (event.pointerType !== 'mouse' || event.button !== 0) return;
        pointer = { id: event.pointerId, x: event.clientX, left: rail.scrollLeft, moved: false };
        suppressClick = false;
      });
      rail.addEventListener('pointermove', event => {
        if (!pointer || event.pointerId !== pointer.id) return;
        const distance = event.clientX - pointer.x;
        if (!pointer.moved && Math.abs(distance) > 6) {
          pointer.moved = true;
          rail.dataset.dragging = 'true';
          rail.setPointerCapture(event.pointerId);
        }
        if (pointer.moved) { rail.scrollLeft = pointer.left - distance; event.preventDefault(); }
      });
      function finishDrag() {
        if (!pointer) return;
        suppressClick = pointer.moved;
        pointer = null;
        delete rail.dataset.dragging;
        setTimeout(() => { suppressClick = false; }, 0);
      }
      rail.addEventListener('pointerup', finishDrag);
      rail.addEventListener('pointercancel', finishDrag);
      rail.addEventListener('pointerleave', () => { if (pointer && !pointer.moved) pointer = null; });
      rail.addEventListener('dragstart', event => event.preventDefault());
      rail.addEventListener('click', event => {
        if (suppressClick) { event.preventDefault(); event.stopImmediatePropagation(); return; }
        const link = event.target.closest('[data-essential-open]');
        if (!link || typeof dialog.showModal !== 'function') return;
        event.preventDefault();
        const template = document.getElementById(link.dataset.essentialOpen);
        body.replaceChildren(template.content.cloneNode(true));
        opener = link;
        previousOverflow = document.documentElement.style.overflow;
        document.documentElement.style.overflow = 'hidden';
        dialog.showModal();
        dialog.querySelector('.essentials-close').focus({ preventScroll: true });
      }, true);
      dialog.querySelector('.essentials-close').addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', event => {
        if (event.target !== dialog) return;
        const rect = dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
      });
      dialog.addEventListener('close', () => {
        document.documentElement.style.overflow = previousOverflow || '';
        body.replaceChildren();
        opener?.focus({ preventScroll: true });
      });
      dialog.addEventListener('change', event => {
        if (!event.target.matches('[data-essential-variant]')) return;
        const option = event.target.selectedOptions[0];
        dialog.querySelector('.essentials-qv-price').textContent = option.dataset.price;
        dialog.querySelector('.essentials-details-link').href = option.dataset.url;
        if (option.dataset.image) {
          const image = dialog.querySelector('.essentials-qv-photo img');
          image.removeAttribute('srcset'); image.src = option.dataset.image;
        }
      });
      updateArrows();
    });
  }
  setup();
  document.addEventListener('shopify:section:load', event => setup(event.target));
})();

  } catch(e) { console.error(e); }
})();
})();
